import type { ComparisonOffer } from '@entities/mto';
import { fmtPriceValue } from '@entities/mto';
import { Muted } from '../styles';

/** Пояснение к КП с истёкшим сроком. */
export function ExpiredNote() {
  return (
    <Muted>
      КП с истёкшим сроком действия — история цен: в минимум они не входят. Запросите у
      поставщика актуальное КП.
    </Muted>
  );
}

/** Минимум по позиции с валютой сравнения (рубль не помечается: минимум в юанях
 *  без подписи читался как рубли). Все КП позиции просрочены — минимума нет,
 *  их цены только история. */
export function MinPrice({
  value,
  currency,
  offers,
}: {
  value: number | null;
  currency: string | null;
  offers: ComparisonOffer[];
}) {
  const onlyHistory =
    value == null &&
    offers.some((o) => o.expired) &&
    !offers.some((o) => o.comparable && !o.expired);
  if (onlyHistory) {
    return <span title="У всех КП по позиции истёк срок действия">нет действующих КП</span>;
  }
  return (
    <>
      {fmtPriceValue(value)}
      {value != null && currency ? ` ${currency}` : ''}
    </>
  );
}
